'use strict';

const { queryFirst, queryAll, addClass, removeClass } = require('./domUtil');
const { INVALID_CLASS, HIDDEN_CLASS } = require('./constants');

/**
 * Show server error on the email field.
 * @param {HTMLInputElement} emailInput
 * @param {HTMLElement|null} errorEl
 * @param {string} message
 */
function showError(emailInput, errorEl, message) {
    if (errorEl && message) {
        errorEl.textContent = message;
    }
    addClass(emailInput, INVALID_CLASS);
}

/**
 * Clear field-level error state.
 * @param {HTMLInputElement} emailInput
 * @param {HTMLElement|null} errorEl
 */
function clearError(emailInput, errorEl) {
    if (errorEl) {
        errorEl.textContent = '';
    }
    removeClass(emailInput, INVALID_CLASS);
}

/**
 * Swap signup copy/form for the thank-you state.
 * @param {HTMLElement} root
 */
function showSuccessState(root) {
    addClass(queryAll('.js-success-hide', root), HIDDEN_CLASS);
    removeClass(queryAll('.js-success-show', root), HIDDEN_CLASS);
}

/**
 * Handle EmailSubscribe-Subscribe JSON response.
 * @param {Object} response
 * @param {HTMLElement} root
 * @param {HTMLInputElement} emailInput
 * @param {HTMLElement|null} errorEl
 * @param {HTMLButtonElement|null} button
 */
function displayMessage(response, root, emailInput, errorEl, button) {
    $.spinner().stop();

    if (button) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        removeClass(button, 'disabled');
    }

    if (response && response.success) {
        clearError(emailInput, errorEl);
        showSuccessState(root);
        $('body').trigger('subscribe:success', { titleElem: root.querySelector('.gated-category-title h2') });
        return;
    }

    showError(emailInput, errorEl, (response && response.msg) || '');
    $('body').trigger('subscribe:fail', { errorEl: errorEl });
}

/**
 * Gated Category signup gate.
 * Client-side field messaging comes from global `clientSideValidation`
 * (`.enable-form-validate`). On valid submit, posts to EmailSubscribe-Subscribe.
 */
document.addEventListener('DOMContentLoaded', () => {
    const form = queryFirst('.js-gated-category-signup form.signup');
    if (!form) {
        return;
    }

    const root = form.closest('.gated-category') || form;
    const emailInput = queryFirst('input[type="email"]', form);
    const errorEl = queryFirst('.invalid-feedback', form);
    const button = queryFirst('button[type="submit"]', form);

    if (!emailInput) {
        return;
    }

    form.addEventListener('submit', async e => {
        e.preventDefault();

        if (form.checkValidity && !form.checkValidity()) {
            return;
        }

        const url = form.getAttribute('action');
        const emailId = emailInput.value;
        if (!url || !emailId) {
            return;
        }

        clearError(emailInput, errorEl);

        if (button) {
            button.disabled = true;
            button.setAttribute('aria-disabled', 'true');
            addClass(button, 'disabled');
        }

        $.spinner().start();
        $('body').trigger('email-submit-button');

        const formData = new FormData();
        formData.append('emailId', emailId);
        formData.append('source', form.dataset.source || 'gatedCategorySignup');

        try {
            const res = await fetch(url, {
                method: 'POST',
                body: formData
            });
            const response = res.ok
                ? await res.json()
                : {
                    error: true,
                    msg: emailInput.dataset.patternMismatch || ''
                };
            displayMessage(response, root, emailInput, errorEl, button);
        } catch (err) {
            displayMessage(
                {
                    error: true,
                    msg: emailInput.dataset.patternMismatch || ''
                },
                root,
                emailInput,
                errorEl,
                button
            );
        }
    });
});
